<div>
    <h2 class="h4">Customize notifications</h2>
    <p>Choose the updates you would like to receive</p>
    <ion-toggle
        (ionChange)="onToggleChange()"
        class="ion-margin-bottom"
        justify="space-between"
        [(ngModel)]="notificationTypes.notify_on_new_jobs"
        [checked]="notificationTypes.notify_on_new_jobs"
        value="notify_on_new_jobs">
        New jobs
    </ion-toggle>

    <ion-toggle
        (ionChange)="onToggleChange()"
        class="ion-margin-bottom"
        justify="space-between"
        [(ngModel)]="notificationTypes.notify_on_system_updates"
        [checked]="notificationTypes.notify_on_system_updates"
        value="notify_on_system_updates">
        System updates
    </ion-toggle>
</div>
